// extracted by mini-css-extract-plugin
module.exports = {"fs18":"n5-img-scroll-module--fs18--3iqy8","fs26":"n5-img-scroll-module--fs26--OKzk_","scroll":"n5-img-scroll-module--scroll--1kbdI"};